<template> 
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:100px;padding-left:45%">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Insurance on the Go!</p>
            <p style="font-size:36px;font-weight:200;font-family:Roboto">Get the MyPICZ app.</p>
          </div>
          <div>
            <p style="font-size:8;font-family:Roboto">With the MyPICZ app, you can register as a client,<br />
            generate quotes, buy insurance, track claims...</p>
          </div>
          <div style="padding-top:20px">
            <p style="color:blue"><span class="mdi mdi-android">Android</span></p>
            <p style="color:blue"><span class="mdi mdi-apple">  iPhone</span></p>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/smart_phone_01.png" alt="" height="700" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'Downloads',
    data() {
      return {
        
        
      }
    },
    methods:{
      downloadFile(){
        axios({
            url: 'http://192.168.1.71:8080/src/uploads/financials/2016_PICZ_Annual_Report.pdf',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');

              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'file.pdf');
              document.body.appendChild(fileLink);

              fileLink.click();
        });
      }
    }
  }
</script>

